'use client';

import { EventFaqBotPage } from '../../../features/event-faq-bot';

interface EventFaqBotContentProps {
  locale: string;
}

export function EventFaqBotContent({ locale }: EventFaqBotContentProps) {
  return <EventFaqBotPage locale={locale} />;
}
